import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAtomValue } from "jotai";
import Button from "../../shared/Button";
import HostBanner from "./components/HostBanner";
import styles from "./ServersView.module.css";
import { hostService } from "../../features/Host/hostService";
import { hostsAtom } from "../../features/Host/hostStore";

const hostUpdateInterval = 5000;

const ServersView = () =>
{
	const navigate = useNavigate();
	const hosts = useAtomValue(hostsAtom);
	const [error, setError] = useState<string | null>(null);

	useEffect(() =>
	{
		let timeoutId: number | null = null;
		let isMounted = true;

		const updateHosts = () =>
		{
			hostService.list()
				.then(() => setError(null))
				.catch((listError: any) =>
				{
					if (listError?.name === "AbortError") return;
					setError(listError instanceof Error ? listError.message : "Failed to load the server hosts");
				})
				.finally(() =>
				{
					if (isMounted)
					{
						timeoutId = setTimeout(updateHosts, hostUpdateInterval);
					}
				});
		};

		updateHosts();

		return () =>
		{
			isMounted = false;
			if (timeoutId !== null)
			{
				clearTimeout(timeoutId);
			}
		};
	}, []);

	return (
		<div className={styles.serversView}>
			<div className={styles.actions}>
				<Button
					label={"Add server"}
					compact
					onClick={() => navigate('/servers/add')}
				/>
			</div>
			<div className={styles.list}>
				{error && <p className={styles.message} role="alert">{error}</p>}
				{!error && hosts.length === 0 && <p className={styles.message}>No server hosts yet. Run the host agent and add it with its code.</p>}
				{hosts.map((host) => <HostBanner key={host.id} host={host} />)}
			</div>
		</div>
	);
};

export default ServersView;